import "@/assets/sass/methodological.scss";
import { useEffect, useState } from "react";
import { Modal } from "antd";
import Store from "@/store";
import { useTranslation } from "react-i18next";
import { downloadFile } from "@/utils";
const NextIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.1332 7.98372L5.0332 4.88372L6.26654 3.65039L10.5999 7.98372L6.26654 12.3171L5.0332 11.0837L8.1332 7.98372Z"
      fill="#576059"
    />
  </svg>
);
export default function Methodological() {
  const [activeTab, setActiveTab] = useState(0);
  const { t } = useTranslation();
  const [modal, contextModalHolder] = Modal.useModal();
  const language = Store.getState().language;

  // 新增函数：显示PDF预览
  const showPdfPreview = () => {
    // 获取PDF文件路径
    const pdfUrl =
      language == "ko"
        ? "/DACCU%20Methodology_ko.pdf"
        : "/DACCU%20Methodology.pdf";

    const pdfFileName =
      language == "ko" ? "DACCU Methodology_ko.pdf" : "DACCU Methodology.pdf";

    // 创建完整URL用于预览
    const fullPdfUrl = window.location.origin + pdfUrl;

    let previewModal = modal.confirm({
      className: "project-modal official-modal pdf-preview-modal",
      title: null,
      width: "80%",
      style: { top: 20 },
      content: (
        <div className="box">
          {/* PDF文件信息 */}
          <div
            style={{
              padding: "15px 20px",
              borderRadius: "20px",
              background: "#F2F8F8",
              fontSize: "16px",
              color: "#2b2b2b",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "20px",
            }}
          >
            <span>{pdfFileName}</span>
            <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 20L8.75 13.75L10.5 11.9375L13.75 15.1875V5H16.25V15.1875L19.5 11.9375L21.25 13.75L15 20ZM7.5 25C6.8125 25 6.22396 24.7552 5.73438 24.2656C5.24479 23.776 5 23.1875 5 22.5V18.75H7.5V22.5H22.5V18.75H25V22.5C25 23.1875 24.7552 23.776 24.2656 24.2656C23.776 24.7552 23.1875 25 22.5 25H7.5Z"
                fill="#1E9662"
              />
            </svg>
          </div>

          {/* PDF预览区域 */}
          <div
            style={{
              width: "100%",
              height: "60vh",
              overflow: "hidden",
              borderRadius: "10px",
              border: "1px solid #eee",
              position: "relative",
            }}
          >
            <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
              <iframe
                src={`${fullPdfUrl}`}
                style={{
                  width: "100%",
                  height: "calc(100% + 40px)" /* 增加高度以隐藏顶部工具栏 */,
                  border: "none",
                  marginTop: "-40px" /* 向上偏移以隐藏顶部工具栏 */,
                }}
                title="PDF Preview"
              ></iframe>
            </div>
          </div>
        </div>
      ),
      footer: (
        <div
          className="d-flex justify-content-center mx-auto"
          style={{ maxWidth: "100%" }}
        >
          <button
            className="cs-btn cs-style1 cs-btn_lg"
            style={{ minWidth: "200px" }}
            onClick={() => {
              previewModal.destroy();
            }}
          >
            <span>{t("common.confirm")}</span>
          </button>
        </div>
      ),
    });
  };
  const alertTip = () => {
    // 获取PDF文件路径
    const pdfUrl =
      language == "ko"
        ? "/Methodology Proposal_ko.pdf"
        : "/Methodology Proposal.pdf";

    const pdfFileName =
      language == "ko"
        ? "Methodology Proposal_ko.pdf"
        : "Methodology Proposal.pdf";

    let mint = modal.confirm({
      className: "project-modal official-modal",
      title: null,
      width: "670px",
      content: (
        <div className="box">
          <h3
            className="title text-center GmarketSans"
            style={{ fontSize: "30px", fontWeight: 700, color: "#2B2B2B" }}
          >
            Direct Air Capture and Utilization
          </h3>
          <div
            style={{
              padding: "28px 20px 28px 20px",
              borderRadius: "20px",
              background: "#F2F8F8",
              fontSize: "16px",
              color: "#2b2b2b",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <span>{pdfFileName}</span>
            <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 20L8.75 13.75L10.5 11.9375L13.75 15.1875V5H16.25V15.1875L19.5 11.9375L21.25 13.75L15 20ZM7.5 25C6.8125 25 6.22396 24.7552 5.73438 24.2656C5.24479 23.776 5 23.1875 5 22.5V18.75H7.5V22.5H22.5V18.75H25V22.5C25 23.1875 24.7552 23.776 24.2656 24.2656C23.776 24.7552 23.1875 25 22.5 25H7.5Z"
                fill="#1E9662"
              />
            </svg>
          </div>
        </div>
      ),
      footer: (
        <div
          className="d-flex gap-3 footer-btn-group mx-auto"
          style={{ maxWidth: "100%" }}
        >
          <button
            className="cs-btn cs-style1 cs-btn_lg flex-1 w-100 hollow"
            onClick={() => {
              mint.destroy();
            }}
          >
            <span>{t("common.close")}</span>
          </button>
          <button
            className="cs-btn cs-style1 cs-btn_lg flex-1 w-100"
            onClick={() => {
              mint.destroy();
              if (language == "ko") {
                // 使用编码后的URL，但显示原始文件名
                downloadFile(
                  "/Methodology Proposal_ko.pdf",
                  "Methodology Proposal_ko.pdf"
                );
              } else {
                downloadFile(
                  "/Methodology Proposal.pdf",
                  "Methodology Proposal.pdf"
                );
              }
            }}
          >
            <span>{t("common.download")}</span>
          </button>
        </div>
      ),
    });
  };
  return (
    <div className="methodological-page">
      {contextModalHolder}
      <section
        className="cs-page_head cs-bg"
        style={{
          backgroundImage: "url(/assets/img/bg_1_2.jpg)",
          height: "338px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div className="container">
          <div className="text-center">
            <h1
              className="cs-page_title gmarket"
              style={{
                position: "relative",
                fontSize: 40,
                color: "white",
                fontWeight: "bold",
                "text-transform": "uppercase",
              }}
            >
              {t("methodological.methodology")}
            </h1>
          </div>
        </div>
      </section>
      <div className="methodological-container container">
        <div className="navs-menus">
          <div className="title">
            {t("methodological.methodology_registration_status")}
          </div>
          <ul className="navs-list">
            <li
              className={"navs-item " + (activeTab == 0 ? "active" : "")}
              onClick={() => {
                setActiveTab(0);
                // 点击时显示PDF预览
                showPdfPreview();
              }}
            >
              <div className="navs-label">
                <span>{t("methodological.registered_methodology")}</span>
                <NextIcon />
              </div>
              <div className="content">
                <div className="item">Direct Air Carbon Capture and Utilization</div>
              </div>
            </li>
            <li
              className={"navs-item " + (activeTab == 1 ? "active" : "")}
              onClick={() => setActiveTab(1)}
            >
              <div className="navs-label">
                <span>
                  {t("methodological.methodologies_pending_registration")}
                </span>
              </div>
              <div className="content">
                <div className="item">Biochar Storage</div>
                <div className="item">
                  Direct Air Capture and Carbon Storage via Ex situ
                  Mineralization
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div className="page-content">
          <div className="methodological-title">
            {t("methodological.methodology_title")}
          </div>
          {language == "ko" && (
            <div className="methodological-info">
              <h5 className="top-cont_title">
                <div className="min-titlef-blue"></div>
                탄소감축의 시작은 신뢰할 수 있는 방법론에서 출발합니다.</h5>

              <div className="top-cont_text">
                탄소를 줄이는 것은 행동만으로 충분하지 않습니다. 감축이 실제로 이루어졌는지를 증명할 수 있어야 합니다.<br />
                캡코투는 과학적 기준에 따라 감축 방식을 정의하고, 국제 기준에 맞춘 방법론을 통해 공정하고 투명한 탄소 시장을 설계합니다.<br />
                당신의 기술, 당신의 프로젝트가 지구의 탄소를 줄이는 정식 기준이 될 수 있습니다.<br />
                지금, 방법론을 등록하고 기후 행동의 기준을 만들어보세요.
              </div>

              <ul className="card-list">
                <li>
                  <div className="item">
                    <p className="tit"><span className="num">1</span>제안서 표지작성</p>
                    <p className="txt">
                      제안서의 표지에는 제안하는 방법론의 명칭을 명확히 기재해야 하며, 해당 방법론이 적용될 수 있는 프로젝트의 유형과 기술 분야(예: DAC, ERW, Biochar 등)를 포함해야 합니다.<br />
                      또한, 방법론이 적용 가능한 프로젝트의 범위를 구체적으로 설명해야 하며, 온실가스 감축이 실제로 가능한지를 판단할 수 있도록 명확한 기준을 제시해야 합니다.
                    </p>
                  </div>
                </li>
                <li>
                  <div className="item">
                    <p className="tit"><span className="num">2</span>프로젝트 경계(Project Boundary)</p>
                    <p className="txt">
                       프로젝트 경계(Project Boundary)는 명확히 설정해야 하며, 경계 내에서 발생하는 온실가스 배출원을 베이스라인과 프로젝트 활동으로 구분하여 제시해야 합니다. 만약 특정 배출원이나 온실가스를 산정 대상에서 제외한다면, 그 이유를 논리적으로 설명해야 합니다.
                    </p>
                  </div>
                </li>
                <li>
                  <div className="item">
                    <p className="tit"><span className="num">3</span>베이스라인 시나리오</p>
                    <p className="txt">
                        베이스라인 시나리오를 설정해야 합니다. 이는 실제 프로젝트가 존재하지 않을 경우 발생했을 상황을 가정하는 것으로, 가능한 시나리오들을 평가하여 가장 적절한 하나를 선정하고, 해당 시나리오가 방법론에 적합한 이유를 서술해야 합니다.<br />
                        아울러, 방법론은 법적·경제적 추가성을 갖추었음을 입증해야 하며, 해외 규제나 정책이 영향을 미치는 경우 그에 대한 평가도 함께 포함되어야 합니다.<br />
                        <br />
                        온실가스 배출량 산정은 베이스라인, 프로젝트 활동, 누출량 각각에 대해 단계별로 수행되어야 하며, 이에 필요한 수식, 계수, 활동자료는 구체적으로 제시하고 단위는 SI 규격을 따라야 합니다. 참고한 문헌이나 기본값이 있는 경우, 그 출처도 명확히 기술해야 합니다.
                        <div className="box_white">
                          * 모니터링 방법론에는 샘플링 위치, 측정 항목, 사용 장비 및 그에 대한 검교정 절차가 포함되어야 하며, QA/QC 절차와 불확도 관리 방안도 함께 제시해야 합니다. 모니터링 항목은 고정 인자(프로젝트 기간 내 변하지 않는 값)와 모니터링 대상 인자로 구분되며, 각각 표로 정리해 출처, 측정방법, 주기 등을 상세히 작성해야 합니다.
                        </div>
                    </p>
                  </div>
                </li>
                <li>
                  <div className="item">
                    <p className="tit"><span className="num">4</span>활용&인용시 주의사항</p>
                    <p className="txt">
                        마지막으로, 기존에 승인된 내·외부 방법론을 참고하거나 활용한 경우, 해당 문헌명과 인용한 부분을 명시하고, 일부 내용을 수정한 경우에는 그 변경 사항과 이유를 명확히 기재해야 합니다.
                    </p>
                  </div>
                </li>
              </ul>

            </div>
          )}
          {language == "en" && (
            <div className="methodological-info">
              <h5 className="top-cont_title">
                <div className="min-titlef-blue"></div>
                Carbon reduction begins with a reliable methodology.</h5>

              <div className="top-cont_text">
                To register a methodology, the following procedures and components must be thoroughly completed.
              </div>

              <ul className="card-list">
                <li>
                  <div className="item">
                    <p className="tit"><span className="num">1</span>The cover page of the proposal</p>
                    <p className="txt">
                       The cover page of the proposal must clearly state the title of the proposed methodology. The title should include the applicable project type and relevant technological field (e.g., DAC, ERW, Biochar, etc.).
                       In addition, the proposal must clearly describe the scope of projects to which the methodology can be applied and present clear criteria to determine whether actual greenhouse gas (GHG) reduction is achievable.
                    </p>
                  </div>
                </li>
                <li>
                  <div className="item">
                    <p className="tit"><span className="num">2</span>Project Boundary</p>
                    <p className="txt">
                        The project boundary must be clearly defined, and all GHG emission sources within the boundary must be classified as either baseline or project activity sources. If any emission source or specific GHG is excluded from the calculation, a logical explanation must be provided.
                    </p>
                  </div>
                </li>
                <li>
                  <div className="item">
                    <p className="tit"><span className="num">3</span>Baseline Scenario</p>
                    <p className="txt">
                        A baseline scenario must be established. This refers to a hypothetical situation that would occur if the project were not implemented. All applicable baseline scenarios should be evaluated, and the most appropriate one selected. The rationale for selecting the scenario and its applicability to the methodology must be explained.
                        The methodology must also demonstrate legal and economic additionality, and if affected by foreign regulations or policies, those impacts must also be evaluated and included.<br />
                        <br />
                        GHG emissions calculations must be carried out step-by-step for the baseline, project activity, and potential leakage. Necessary formulas, emission factors, and activity data must be clearly presented, with all variables expressed in SI units. Any referenced literature or default values must be properly cited.
                        <div className="box_white">
                           * The monitoring methodology must include details on sampling locations, measurement parameters, measuring equipment, and calibration procedures. Additionally, QA/QC procedures and uncertainty management strategies must be described. Monitoring items should be divided into fixed parameters (unchanging during the project period) and monitored parameters, with each clearly organized in tables including data sources, measurement methods, and monitoring frequency.
                        </div>
                    </p>
                  </div>
                </li>
                <li>
                  <div className="item">
                    <p className="tit"><span className="num">4</span>Precautions when using & quoting</p>
                    <p className="txt">
                         Finally, if any part of the methodology references or utilizes previously approved internal or external methodologies, the referenced documents and specific sections must be cited. If modifications are made, the changes and reasons for those changes must be clearly explained.
                    </p>
                  </div>
                </li>
              </ul>

            </div>
          )}
          <button
            className="cs-btn cs-style1"
            style={{ borderRadius: "10px", float: "right", marginTop: "20px" }}
          >
            <span style={{ position: "relative" }} onClick={alertTip}>
              {t("methodological.download")}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}
